<template>
  <v-card>
    <v-list style="cursor: pointer; background-color: rgb(84, 86, 107);">
      <v-list-item @click.native.stop style="cursor: text">
        <v-avatar class="mr-2" size="50">
          <img v-if="avatar" :src="avatar" alt="avatar" />
          <img v-if="!avatar" src="@/assets/user-placeholder.png" alt="avatar" />
        </v-avatar>
        <v-list-item-content>
          <v-list-item-title class="white--text">
            {{ auth.name }}
          </v-list-item-title>

          <v-list-item-subtitle class="white--text">
            {{ auth.email }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider class="mt-n1"></v-divider>

    <v-list style="cursor: pointer">
      <v-list-item @click="$router.push('/user/profile')" class="my-n4">
        <v-list-item-content>
          <v-list-item-title>
            Acessar o perfil
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="primary" text @click="logout()">Sair</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex';
import MovideskHelper from '@/helpers/MovideskHelper';
import AuthenticationRepository from '@/repositories/AuthenticationRepository';

export default {
  name: 'AccountManager',
  data: () => ({
    auth: {},
    avatar: null,
    authenticationRepository: new AuthenticationRepository(),
  }),
  mounted() {
    this.fetch();
  },
  methods: {
    ...mapMutations('authentication', ['resetUser']),
    fetch() {
      this.loadUser();
    },
    loadUser() {
      const userData = this.$session.getAll();

      const user = {
        company_group: {
          name: userData.company_group_name,
          image: userData.company_group_image,
          id: userData.company_group_id,
        },
        name: userData.name,
        email: userData.email,
      };

      this.auth = user;
    },
    async logout() {
      MovideskHelper.setVisibilityOfChat(document.getElementById('md-app-widget'), 'hidden');
      MovideskHelper.removeMovideskScript(document.getElementById('mdChatClient'), document);

      this.removeHubSpotChat();

      await this.authenticationRepository.removeHttpCookie();
      this.resetUser();
      this.$router.push({ name: 'login' });
    },
    removeHubSpotChat() {
      const w = window;

      // 1. Operações com a API do HubSpot (antes de remover o script)
      if (w.HubSpotConversations) {
        try {
          w.hsConversationsSettings = {
            identificationEmail: null,
            identificationToken: null,
          };

          this.$nextTick(() => {
            const iframeHubspotEl = document.getElementById('hubspot-conversations-iframe');

            if (iframeHubspotEl) {
              iframeHubspotEl.style.setProperty('display', 'none', 'important');
            }
          });
        } catch (e) {
          console.log('HubSpot cleanup error:', e);
        }
      }

      // 2. Remove o script
      const script = document.getElementById('hs-script-loader');
      if (script) {
        script.remove();
      }

      // 3. Limpa as configurações globais
      w.hsConversationsSettings = undefined;
      w.hsConversationsOnReady = undefined;

      // 4. Remove TODOS os elementos do HubSpot do DOM (mais abrangente)
      const selectors = [
        '[id^="hubspot"]',
        '[class*="hs-"]',
        'iframe[src*="hubspot"]',
        'iframe[src*="hs-scripts"]',
        'iframe[src*="hs-banner"]',
        '#hs-web-interactives-top-anchor',
        '#hs-web-interactives-bottom-anchor',
        '[id^="hs-"]',
        '[data-hubspot-wrapper]',
      ];

      const hubspotElements = document.querySelectorAll(selectors.join(', '));
      hubspotElements.forEach((el) => el.remove());

      // 5. Limpa a referência global do HubSpot
      delete w.HubSpotConversations;
    },
  },
};
</script>
